import { render, staticRenderFns } from "./QueueSelect.vue?vue&type=template&id=20341192&scoped=true"
import script from "./QueueSelect.vue?vue&type=script&lang=js"
export * from "./QueueSelect.vue?vue&type=script&lang=js"
import style0 from "./QueueSelect.vue?vue&type=style&index=0&id=20341192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20341192",
  null
  
)

export default component.exports